import { isArray } from 'util';
import { SimpleRefrigeration } from '../simple-refrigeration';

export class SimpleRefrigerationBuilder {
  static fromJson(json) {
    return (json)
      ? new SimpleRefrigeration(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(SimpleRefrigerationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/simple-refrigeration.builder.ts